import { NIcon, MenuOption } from "naive-ui";
import { Component, h } from "vue";
import { RouterLink } from "vue-router";
import { FullUser } from "@/domain/user";
import { urlForDownload } from "@/core/utils";
import AuthorizedImage from "@/components/ui/AuthorizedImage.vue";
import globalStore from "@/core/store/globalStore";
import {
	MailOutline,
	ListOutline,
	DocumentTextOutline,
	BookOutline,
	LogOutOutline,
	FolderOutline,
	PersonOutline,
	AlbumsOutline,
	PeopleOutline,
} from "@vicons/ionicons5";
import LogoLatter32 from "@/shared/assets/img/logo_letter_32px.svg";
import LogoTxt from "@/shared/assets/img/logo_txt.svg";
function renderIcon(icon: Component) {
	return () => h(NIcon, null, { default: () => h(icon) });
}

function renderPhoto() {
	return () => h(NIcon, { size: 32 }, () => h("img", { src: LogoLatter32 }));
}

function renderAvatar(src: string) {
	return () => h(NIcon, { size: 32 }, () => h(AuthorizedImage, { src: urlForDownload(src, 64), class: "side-bar__avatar" }));
}

function renderBots(src: string) {
	return () => h(NIcon, { size: 32 }, () => h(AuthorizedImage, { src: urlForDownload(src, 0), class: "side-bar__bots" }));
}

export const getMenuOption = (user: FullUser | null, getUnreadTaskCounter: number): MenuOption[] => {
	return [
		{
			label: () => h("img", { src: LogoTxt }),
			key: "logo",
			icon: renderPhoto(),
			disabled: true,
		},
		{
			label: user === null ? "Профиль" : `${user.info.name} ${user.info.surname}`,
			key: "profile",
			icon:
				user === null || user.avatar_url === "" || user.avatar_url === null
					? renderIcon(PersonOutline)
					: renderAvatar(user.avatar_url),
			children: [
				{
					label: () =>
						h(
							RouterLink,
							{ to: { name: "Profile", params: { id: globalStore.getters.getCurrentUser.id } } },
							{ default: () => "Профиль" },
						),
					key: "profile-link",
					icon: renderIcon(PersonOutline),
				},
				{
					label: () => h(RouterLink, { to: { name: "Login" } }, { default: () => "Выйти" }),
					key: "logout-link",
					icon: renderIcon(LogOutOutline),
				},
			],
		},
		{
			label: () =>
				h(
					RouterLink,
					{ to: { name: "TaskListIncoming" } },
					{
						default: () =>
							h("div", { class: "menu-tasklist__title" }, [
								h("span", {}, "Входяшие"),
								h("span", { class: "unread-task__counter" }, getUnreadTaskCounter),
							]),
					},
				),
			key: "in",
			icon: renderIcon(MailOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "TaskList" } }, { default: () => "Все задачи" }),
			key: "all-task",
			icon: renderIcon(ListOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "FormList" } }, { default: () => "Формы" }),
			key: "forms-link",
			icon: renderIcon(DocumentTextOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "CatalogList" } }, { default: () => "Справочники" }),
			key: "catalogs-link",
			icon: renderIcon(BookOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "Departments" } }, { default: () => "Отделы" }),
			key: "departments-link",
			icon: renderIcon(FolderOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "BotsList" } }, { default: () => "Список ботов" }),
			key: "bot-link",
			icon: renderBots("/files/260127271562f782e6de9c80868cd253/bots.svg"),
		},
		{
			label: () => h(RouterLink, { to: { name: "Profiles" } }, { default: () => "Пользователи" }),
			key: "profiles-link",
			icon: renderIcon(PeopleOutline),
		},
		{
			label: () => h(RouterLink, { to: { name: "Company" } }, { default: () => "Компания" }),
			key: "company-link",
			icon: renderIcon(AlbumsOutline),
		},
	];
};
